<template>
  <div>
    <table class="min-w-full divide-y divide-gray-200">
      <thead class="bg-gray-50">
        <tr>
          <!-- <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
              >
                Select
              </th> -->
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Name
          </th>

          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Phone
          </th>
          <th
            scope="col"
            class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
          >
            Actions
          </th>
        </tr>
      </thead>
      <tbody class="bg-white divide-y divide-gray-200">
        <!-- {{ selected }} -->
        <tr v-for="(user, index) in paginated" :key="index">
          <!-- <td class="px-6 py-4 whitespace-nowrap">
                <div class="text-sm text-gray-900">
                  <input
                    type="checkbox"
                    :value="user"
                    v-model="selected"
                  />
                </div>
              </td> -->

          <!-- <td class="px-6 py-4 whitespace-nowrap">
                <div class="text-sm text-gray-900">
                  {{ indexStart + ++index }}
                </div>
              </td> -->

          <td class="px-6 py-4 whitespace-nowrap">
            <div class="flex items-center">
              <div class="ml-4">
                <div class="text-sm font-medium text-gray-900">
                  {{ user.name }}
                </div>
                <div class="text-sm text-gray-500">
                  {{ user.email }}
                </div>
              </div>
            </div>
          </td>

          <td class="px-6 py-4 whitespace-nowrap">
            <span
              class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-gray-100 text-gray-600"
            >
              Tel: {{ user.number }}
            </span>
          </td>

          <td
            class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium"
          >
            <button
              @click="createContact(user)"
              class="font-bold bg-green-600 px-3 rounded py-2 text-white text-xs hover:bg-green-700"
            >
              Import
            </button>
            <!-- <button @click="archiveClient(user)" class="ml-2 font-bold bg-red-100 px-1 mt-2 rounded py-1 text-red-600 text-xs hover:text-indigo-600">Archive</button> -->
          </td>
        </tr>
      </tbody>
    </table>

    <nav
      class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6"
      aria-label="Pagination"
    >
      <div class="hidden sm:block">
        <p class="text-sm text-gray-700">
          Showing Page
          <span
            class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800"
          >
            {{ current }}
          </span>
        </p>
      </div>
      <div class="flex-1 flex justify-between sm:justify-end">
        <a
          @click="prev"
          href="#"
          class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
        >
          Previous
        </a>
        <a
          @click="next()"
          href="#"
          class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
        >
          Next
        </a>
      </div>
    </nav>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: {
    source: String,
    imported: Array
  },

  data() {
    return {
      selected: [],
      selectAll: false,

      current: 1,
      pageSize: 8,
      newContacts: this.imported
    };
  },

  computed: {
    indexStart() {
      return (this.current - 1) * this.pageSize;
    },
    indexEnd() {
      return this.indexStart + this.pageSize;
    },
    paginated() {
      return this.newContacts.slice(this.indexStart, this.indexEnd);
    }
  },

  methods: {
    select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.newContacts) {
          this.selected.push(this.newContacts[i].id);
        }
      }
    },

    prev() {
      this.current--;
    },
    next() {
      this.current++;
    },

    showMessage(item) {
      this.selectedMessage = true;
      this.messageSelected = item;
    },

    closeSelectedMessage() {
      this.selectedMessage = false;
      this.messageSelected = "";
    },

    createContact(user) {
      let contact = new FormData();
      contact.append("source", "homemanager");
      contact.append("name", user.name);
      contact.append("email", user.email);
      contact.append("phone", user.number);

      window.axios.post("/api/crm", contact).then(res => {
        if (res.data === "exists") {
          Swal.fire({
            icon: "error",
            title: "Duplicate Email",
            text:
              "This email is already register as a contact please try another"
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "Contact successfully added"
          });

          this.$emit("event");
        }
      });
    }
  }
};
</script>
